import CigDialog from './src/index.vue'
import type { App } from 'vue'
import type { SFCWithInstall } from '@park-ui/utils'

CigDialog.install = (app: App): void => {
  app.component(CigDialog.name, CigDialog)
}

const _CigDialog = CigDialog as SFCWithInstall<typeof CigDialog>

export default CigDialog
export const ElCigDialog = _CigDialog
